












import axios from "axios";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class Map extends Vue {
  dataset: any[] = [];

  get columns() {
    return [
      { title: "ID", key: "id", width: 80 },
      { title: "Source", key: "source", width: 180 },
      {
        title: "Created At",
        key: "created_at",
        width: 180,
        render: (h: any, params: any) =>
          h("span", params.row.created_at.toString().substring(0, 10)),
      },
      {
        title: "Type",
        width: 180,
        render: (h: any, params: any) =>
          h("span", params.row.data.attributes.type),
      },
      {
        title: "Hazard Name",
        render: (h: any, params: any) =>
          h("span", params.row.data.attributes.hazard_name),
      },
    ];
  }

  async created() {
    const response = await axios.get("/psql/parking_lot", {
      params: {
        type: "eq.events",
        status: "eq.waiting",
        order: "created_at",
      },
    });
    this.dataset = response.data;
  }
}
